import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import ComparisLogo from '../../images/Logo_Comparis.svg';

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <footer className='bg-darkGray w-full text-center sm:text-left'>
      <div className='container p-5 w-full sm:min-w-full '>
        <div className='grid grid-cols-1 sm:grid-cols-4'>
          <div className='mb-5 mt-2 sm:justify-self-center font-press-start'>
            <ul className='list-none mb-0'>
              <li className=''>
                <Link to='/auctionic' className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150'>
                  AUCTIONIC AG
                </Link>
              </li>
              <li className=''>
                <Link to='/listingItem' state={{ type: 'auction' }}
                  className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150' onClick={() => navigate('/listingItem', { state: { type: 'auction' } })}>
                  {t('footer.advertise')}
                </Link>
              </li>
              <li>
                <Link to='how_it_works' className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150'>
                  {t('footer.howItWorks')}
                </Link>
              </li>
            </ul>
          </div>
          <div className='mb-5 mt-2  justify-self-center font-press-start'>
            <ul className='list-none mb-0'>
              <li>
                <Link to='/contact' className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150'>
                  {t('footer.contact')}
                </Link>
              </li>
              <li>
                <Link to='/jobs' className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150'>
                  {t('footer.jobs')}
                </Link>
              </li>
              <li>
                <Link to='/media' className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150'>
                  {t('footer.media')}
                </Link>
              </li>
            </ul>
          </div>
          <div className='mb-5 mt-2  justify-self-center font-press-start'>
            <ul className='list-none mb-0'>
              <li>
                <Link to='/terms/conditions' className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150'>
                  {t('footer.legal')}
                </Link>
              </li>
              <li>
                <Link to='/privacy/policy' className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150'>
                  {t('footer.dataProtection')}
                </Link>
              </li>
              <li>
                <Link to='/impressum' className='text-white hover:border-b hover:border-b-white transition-all ease-in-out duration-150'>
                  Impressum
                </Link>
              </li>
            </ul>
          </div>
          <div className='sm:flex mb-5 mt-2  ml-4 justify-self-center items-center justify-center'>
            <div className='text-white'>
              Partner
              <img
                className=''
                src={ComparisLogo}
                alt=''
              />
            </div>
            <div className='flex justify-center'>
              {/* <rect xmlns="http://www.w3.org/2000/svg" height="107.005" id="_21.-SSL"  width="140.103" x="162.356" y="155.758"/> */}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='172.42 165.827 130.068 62.053'
                className='w-[80px] h-[80px]'
              >
                <path
                  fill='white'
                  d='M 260.662 202.95 L 260.596 202.952 C 255.451 202.952 251.275 199.251 251.275 194.694 L 251.275 187.87 C 251.275 183.312 255.451 179.612 260.596 179.612 C 265.741 179.612 269.917 183.312 269.917 187.87 L 269.917 194.694 C 269.917 199.192 265.849 202.855 260.796 202.948 C 263.541 202.904 265.755 200.914 265.755 198.47 L 265.755 188.126 C 265.755 185.652 263.488 183.644 260.696 183.644 C 257.903 183.644 255.636 185.652 255.636 188.126 L 255.636 198.47 C 255.636 200.934 257.886 202.937 260.662 202.95 Z'
                ></path>
                <path
                  fill='white'
                  d='M 272.7 194.101 C 272.7 192.205 270.962 190.665 268.821 190.665 L 252.179 190.665 C 250.038 190.665 248.3 192.205 248.3 194.101 L 248.3 204.958 C 248.3 206.854 250.038 208.394 252.179 208.394 L 268.821 208.394 C 270.962 208.394 272.7 206.854 272.7 204.958 L 272.7 194.101 Z'
                ></path>
                <path
                  fill='black'
                  d='M 258.971 200.146 C 257.94 199.742 257.223 198.845 257.223 197.805 C 257.223 196.385 258.558 195.233 260.201 195.233 C 261.845 195.233 263.179 196.385 263.179 197.805 C 263.179 198.906 262.375 199.847 261.248 200.213 L 261.248 201.943 C 261.248 202.5 260.737 202.952 260.109 202.952 C 259.481 202.952 258.971 202.5 258.971 201.943 L 258.971 200.146 Z'
                ></path>
                <g xmlns="http://www.w3.org/2000/svg" id="SSL" transform="matrix(0.361432, 0, 0, 0.320215, 162.141159, 155.483505)">
                  <path
                    fill='white'
                    d='M120.978,136.061c0,-19.295 -29.68,-13.793 -29.68,-22.007c0,-3.1 2.635,-5.192 7.362,-5.192c3.797,0 7.827,0.93 11.391,2.944c0.93,0.543 1.86,0.775 2.79,0.775c2.635,0 5.502,-2.014 5.502,-4.959c0,-0.93 -0.31,-1.86 -0.93,-2.635c-2.867,-3.797 -11.856,-5.734 -17.745,-5.734c-12.167,0 -19.606,7.129 -19.606,15.731c0,19.45 29.757,13.173 29.757,22.317c0,2.945 -2.945,5.735 -8.989,5.735c-5.037,0 -9.454,-1.628 -12.941,-4.03c-0.853,-0.62 -1.937,-0.852 -2.945,-0.852c-2.635,0 -5.192,2.169 -5.192,5.114c0,0.93 0.31,1.86 0.853,2.635c2.867,4.262 12.166,6.742 19.682,6.742c13.949,0 20.691,-7.13 20.691,-16.584Z'
                  ></path>
                  <path
                    fill='white'
                    d='M167.473,136.061c0,-19.295 -29.68,-13.793 -29.68,-22.007c0,-3.1 2.635,-5.192 7.362,-5.192c3.797,0 7.827,0.93 11.391,2.944c0.93,0.543 1.86,0.775 2.79,0.775c2.635,0 5.502,-2.014 5.502,-4.959c0,-0.93 -0.31,-1.86 -0.93,-2.635c-2.867,-3.797 -11.856,-5.734 -17.745,-5.734c-12.167,0 -19.606,7.129 -19.606,15.731c0,19.45 29.757,13.173 29.757,22.317c0,2.945 -2.945,5.735 -8.989,5.735c-5.037,0 -9.454,-1.628 -12.941,-4.03c-0.853,-0.62 -1.937,-0.852 -2.945,-0.852c-2.635,0 -5.192,2.169 -5.192,5.114c0,0.93 0.31,1.86 0.853,2.635c2.867,4.262 12.166,6.742 19.683,6.742c13.948,0 20.69,-7.13 20.69,-16.584Z'
                  ></path>
                  <path
                    fill='white'
                    d='M208.233,146.755c0,-2.557 -2.169,-4.727 -4.727,-4.727l-17.59,0l0,-37.041c0,-2.944 -2.48,-5.424 -5.425,-5.424c-3.099,0 -5.579,2.48 -5.579,5.424l0,40.528c0,3.41 2.79,6.2 6.199,6.2l22.395,0c2.558,0 4.727,-2.17 4.727,-4.96Z'
                  ></path>
                </g>
                {/* <rect xmlns="http://www.w3.org/2000/svg" x="185.257" y="176.944" width="101.167" height="35.923" stroke='white' strokeWidth={2}/> */}
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className='flex justify-center items-center ml-[30px]'>
        <a href='https://facebook.com/auctionic.ch' target='_blank' rel="noreferrer" className='mr-9 text-white hover:scale-110 transition-all ease-in-out duration-150'>
          <svg
            aria-hidden='true'
            focusable='false'
            data-prefix='fab'
            data-icon='facebook-f'
            className='svg-inline--fa fa-facebook-f w-2.5'
            role='img'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 320 512'
          >
            <path
              fill='currentColor'
              d='M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z'
            ></path>
          </svg>
        </a>
        <a href='https://twitter.com/auctionic_ch' target='_blank' rel="noreferrer" className='mr-9 text-white hover:scale-110 transition-all ease-in-out duration-150'>
          <svg
            aria-hidden='true'
            focusable='false'
            data-prefix='fab'
            data-icon='twitter'
            className='svg-inline--fa fa-twitter w-4'
            role='img'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 512 512'
          >
            <path
              fill='currentColor'
              d='M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z'
            ></path>
          </svg>
        </a>
        <a href='https://instagram.com/auctionic.ch/' target='_blank' rel="noreferrer" className='mr-9 text-white hover:scale-110 transition-all ease-in-out duration-150'>
          <svg
            aria-hidden='true'
            focusable='false'
            data-prefix='fab'
            data-icon='instagram'
            className='svg-inline--fa fa-instagram w-4'
            role='img'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 448 512'
          >
            <path
              fill='currentColor'
              d='M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z'
            ></path>
          </svg>
        </a>
        <a href='https://www.linkedin.com/company/auctionic-ag/' target='_blank' rel="noreferrer" className='mr-9 text-white hover:scale-110 transition-all ease-in-out duration-150'>
          <svg
            aria-hidden='true'
            focusable='false'
            data-prefix='fab'
            data-icon='linkedin'
            className='svg-inline--fa fa-linkedin w-4'
            role='img'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 448 512'
          >
            <path
              fill='currentColor'
              d='M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z'
            ></path>
          </svg>
        </a>
        {/* <a href='https://xing.com/auctionic.ch' target='_blank' rel="noreferrer" className='mr-9 text-white hover:text-blue-500 transition-all ease-in-out duration-150'>*/}
        {/*  <svg*/}
        {/*    aria-hidden='true'*/}
        {/*    focusable='false'*/}
        {/*    data-prefix='fab'*/}
        {/*    data-icon='xing'*/}
        {/*    className='svg-inline--fa fa-xing w-4'*/}
        {/*    role='img'*/}
        {/*    xmlns='http://www.w3.org/2000/svg'*/}
        {/*    viewBox='0 0 448 512'*/}
        {/*  >*/}
        {/*    <path*/}
        {/*      fill='currentColor'*/}
        {/*      d='M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z'*/}
        {/*    ></path>*/}
        {/*  </svg>*/}
        {/* </a>*/}
        <a href='https://www.youtube.com/channel/UCOPD-XVS_KUiG-tk-FPbNzw' target='_blank' rel="noreferrer" className='mr-9 hover:scale-110 text-white transition-all ease-in-out duration-150'>
          <svg
            aria-hidden='true'
            focusable='false'
            data-prefix='fab'
            data-icon='youtube'
            className='svg-inline--fa fa-youtube w-5'
            role='img'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 448 512'
          >
            <path
              fill='currentColor'
              d='M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z'
            ></path>
          </svg>
        </a>
        <a href='https://www.tiktok.com/@auctionic' target='_blank' rel="noreferrer" className='mr-9 text-white hover:scale-110 transition-all ease-in-out duration-150'>
          <svg fill="#fff"
            className='svg-inline--fa fa-tiktok w-6'
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50" width="50px" height="50px">
            <path d="M 9 4 C 6.2495759 4 4 6.2495759 4 9 L 4 41 C 4 43.750424 6.2495759 46 9 46 L 41 46 C 43.750424 46 46 43.750424 46 41 L 46 9 C 46 6.2495759 43.750424 4 41 4 L 9 4 z M 9 6 L 41 6 C 42.671576 6 44 7.3284241 44 9 L 44 41 C 44 42.671576 42.671576 44 41 44 L 9 44 C 7.3284241 44 6 42.671576 6 41 L 6 9 C 6 7.3284241 7.3284241 6 9 6 z M 26.042969 10 A 1.0001 1.0001 0 0 0 25.042969 10.998047 C 25.042969 10.998047 25.031984 15.873262 25.021484 20.759766 C 25.016184 23.203017 25.009799 25.64879 25.005859 27.490234 C 25.001922 29.331679 25 30.496833 25 30.59375 C 25 32.409009 23.351421 33.892578 21.472656 33.892578 C 19.608867 33.892578 18.121094 32.402853 18.121094 30.539062 C 18.121094 28.675273 19.608867 27.1875 21.472656 27.1875 C 21.535796 27.1875 21.663054 27.208245 21.880859 27.234375 A 1.0001 1.0001 0 0 0 23 26.240234 L 23 22.039062 A 1.0001 1.0001 0 0 0 22.0625 21.041016 C 21.906673 21.031216 21.710581 21.011719 21.472656 21.011719 C 16.223131 21.011719 11.945313 25.289537 11.945312 30.539062 C 11.945312 35.788589 16.223131 40.066406 21.472656 40.066406 C 26.72204 40.066409 31 35.788588 31 30.539062 L 31 21.490234 C 32.454611 22.653646 34.267517 23.390625 36.269531 23.390625 C 36.542588 23.390625 36.802305 23.374442 37.050781 23.351562 A 1.0001 1.0001 0 0 0 37.958984 22.355469 L 37.958984 17.685547 A 1.0001 1.0001 0 0 0 37.03125 16.6875 C 33.886609 16.461891 31.379838 14.012216 31.052734 10.896484 A 1.0001 1.0001 0 0 0 30.058594 10 L 26.042969 10 z M 27.041016 12 L 29.322266 12 C 30.049047 15.2987 32.626734 17.814404 35.958984 18.445312 L 35.958984 21.310547 C 33.820114 21.201935 31.941489 20.134948 30.835938 18.453125 A 1.0001 1.0001 0 0 0 29 19.003906 L 29 30.539062 C 29 34.707538 25.641273 38.066406 21.472656 38.066406 C 17.304181 38.066406 13.945312 34.707538 13.945312 30.539062 C 13.945312 26.538539 17.066083 23.363182 21 23.107422 L 21 25.283203 C 18.286416 25.535721 16.121094 27.762246 16.121094 30.539062 C 16.121094 33.483274 18.528445 35.892578 21.472656 35.892578 C 24.401892 35.892578 27 33.586491 27 30.59375 C 27 30.64267 27.001859 29.335571 27.005859 27.494141 C 27.009759 25.65271 27.016224 23.20692 27.021484 20.763672 C 27.030884 16.376775 27.039186 12.849206 27.041016 12 z"/>
          </svg>
        </a>
      </div>
      <div className='text-gray-200 text-center p-5 font-press-start grid grid-cols-1 align-center sm:justify-self-center'>
        <div className='flex self-center justify-center'>
          © {new Date().getFullYear()} Copyright:
          <a className='text-gray-200 font-press-start' href='https://auctionic.ch/'>
            {' '}
            &nbsp;AUCTIONIC AG
          </a>
        </div>
      </div>
    </footer>
  );
};
export { Footer };
